
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component<LoadingCard>({})
export default class LoadingCard extends Vue {
    @Prop({ type: String, default: 'default' })
    public readonly variant!:
        | 'default'
        | 'graph'
        | 'pill'
        | 'single'
        | 'table'
        | 'columns'
        | 'circle'
    @Prop({ type: Boolean, default: false })
    public readonly borderless!: boolean
}
